import { Action, CustomPermissions, SetPermissionSettingsDispatch } from "@connect/Interfaces";
import { ACTION_TYPES } from "Data/Objects/ActionTypes";
import { DispatchableAction } from "Data/Objects/DispatchableAction";

const { SET_PERMISSIONS } = ACTION_TYPES.Permissions;

export function setPermissionSettings(permissions: CustomPermissions): Action<SetPermissionSettingsDispatch> {
	return new DispatchableAction(SET_PERMISSIONS, { permissions });
}
